module.exports = __webpack_public_path__ + "static/media/biscuits.d734eee2.JPG";